import React from "react";
import { useNavigate } from "react-router-dom";

export default function DesktopView() {
  const naviagte = useNavigate();
  return (
    <>
      <div className="relative w-full h-screen flex flex-col items-center justify-center bg-[#02161D]">
        <div className="relative w-[50vw] h-[30vh] rounded-[1.2vw] flex items-start justify-center bg-color-primary-B">
          <div className="relative h-full flex items-center justify-center w-[70%]">
            <div className="flex flex-col justify-center">
              <p className="w-full font-font_primary_A font-bold text-[1.1vw] text-center">
                به‌منظور استفاده از خدمات اسکارپین بایستی با موبایل وارد شوید.
              </p>
              <div className="w-full flex justify-center mt-[2.5vw]">
                <a
                  href="https://scarpin.ir/"
                  className="w-[50%] h-[2vw] flex items-center justify-center bg-[#153038] text-[1vw] text-[#F4F4F4] font-font_primary_A rounded-[0.6vw]"
                >
                  متوجه شدم
                </a>
              </div>
            </div>
          </div>
          <div className="relative flex items-center justify-center h-full w-[30%] border-r-[0.5vw] border-r-[#02161D] ">
            <img
              src="../assets/images/desktop-view/desk-logo.png"
              className="w-[10vw] h-[10vw]"
            />
          </div>
        </div>
        <div className="flex items-center justify-start  w-[50vw] mr-[2.5vw] mt-[0.5vw] font-font_primary_A gap-x-[0.5vw]">
          <div className=" w-[0.5vw] h-[0.5vw] top-0 right-0 rounded-full bg-color-primary-B"></div>
          <p
            className="text-color-primary-B text-[0.5vw] hover:text-color-primary-A cursor-pointer"
            onClick={() => {
              window.open("https://scarpin.ir/links/app", "_blank");
            }}
          >
            لینک دانلود اپلیکیشن اسکارپین
          </p>
        </div>
      </div>
    </>
  );
}
